import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageSectionBase } from 'shared/components/ui/page-section-base';
import { useTrackPageVisitEvent } from 'shared/hooks/use-track-page-visit-event';
import { PageEvents } from 'shared/services/tracking';

import { CompletedTasks } from './components/completed-tasks';
import { TasksOverview } from './components/tasks-overview';
import * as Styled from './life-area-detail.style';

export const Tasks: React.FC = () => {
  const { t } = useTranslation();
  useTrackPageVisitEvent(PageEvents.LifeAreaDetailTasks, undefined);

  return (
    <PageSectionBase
      title={t('pages.life-area-detail.sections.tasks.label')}
      fullSize
      noPadding
    >
      <Styled.ScrollContainer>
        <TasksOverview />
        <CompletedTasks />
      </Styled.ScrollContainer>
    </PageSectionBase>
  );
};
